<template>
  <div class="material-detail-container container">


    <template v-if="!spider">

      <!--      <CouponModal ref="CouponModal"></CouponModal>-->

      <!-- 续费通知 -->
      <VipRenewalNotice/>


      <!-- 盈利弹框 -->
      <ProfitModal
        ref="ProfitModal"
        @navigatorToPay="navigatorToPay"
        @limitTag="limitTag"
      />

      <!--  企业优惠券弹框 -->
      <ReceiveCompanyCouponDialog
        ref="ReceiveCompanyCouponDialog"
        :download-way="downloadWay"
        :couponReceiveState="couponReceiveState"
      />

      <!-- 下载限制弹框 -->
      <DownloadInterceptDialog
        ref="DownloadInterceptDialog"
        :time="clippingTime"
      />


      <!--  图片包支付弹框 -->
      <PicPackagePayModal ref="PicPackagePayModal"/>

      <CompanyCertificateDialog
        ref="CompanyCertificateDialog"
        :type="type"
      />

      <!--      <websiteRatingModel/>-->

    </template>

    <div class="inner-box ">
      <div class="inner-container">

        <!-- 详情页面包屑 -->
        <div class="bread-crumbs-box">

          <DetailBreadCrumbs
            :pic-category="picCategory"
            :detail="detail"
            :PAGE_PATH="PAGE_PATH"
          />
          <no-ssr>

          </no-ssr>

        </div>
        <!-- 普通图片面板 -->
        <PicPanel
          ref="PicPanel"
          v-if="detail.package !== 1"
          :detail="detail"
          :show-img-panel="showImgPanel"
          :is-collect="isCollect"
          :pic-package-desc="picPackageDesc"
          :pic-package-desc-state="picPackageDescState"
          :picInfo="picInfo"
          :picInfoIsShow="picInfoIsShow"
          :customAHref="customAHref"
          @toggleLike="toggleLike"
          @download="download"
        >
          <div class="picPanelContent" slot="picContent">
            <!--            <DetailInviteDown
                          class="DetailInviteDown"
                          v-if="detail.package !== 1 && isLogin && inviteDownInfo.limit < 10 "
                          :detail="detail"
                          :inviteDownInfo="inviteDownInfo"
                          :isShow="isShowSuccDialog"
                          :isNotVip="isNotVip"
                          :isShowByFailDialog="isShowByFailDialog"
                          @close="isShowByFailDialog = false"
                          @closeFailDialog="isShowByFailDialog = false"
                          @shareDown="shareDown"
                        />-->
          </div>

        </PicPanel>

        <!-- 图片包面板 -->
        <PicPackagePanel
          v-else
          :detail="detail"
          :show-img-panel="showImgPanel"
          :is-collect="isCollect"
          :pic-package-desc="picPackageDesc"
          :pic-package-desc-state="picPackageDescState"
          :is-buy-pic-package="isBuyPicPackage"
          :picInfo="picInfo"
          :picInfoIsShow="picInfoIsShow"
          :customAHref="customAHref"
          @showPayDialog="showPayDialog"
          @showPayVipDialog="toggleVip"
          @toggleLike="toggleLike"
        >


        </PicPackagePanel>

      </div>

      <div>
        <DetailCaption
          :detail="detail"
          :seo_words="seo_words"
          :isSpider="isSpider"
        />

        <!-- 图片资源 -->
        <PicResources
          class="PicResources"
          v-show="picResourcesState"
          :pic-package-desc-state="picPackageDescState"
          :trendPicsCover="trendPicsCover"
          :pic-package-desc="picPackageDesc"
          :pic-resources="picResources"
          :is-buy-pic-package="isBuyPicPackage"
          @showPayDialog="showPayDialog"
          :detail="detail"
        />


        <CollectionRecommend
          v-if="topicList.length > 1"
          class="CollectionRecommend" :pic-list="topicList"
          topicTitle="更多专题"
          @picItemTopicClick="picItemTopicClick"
          @topicMouseover="topicMouseover"
        >
          <i slot="icon" class="iconfont icon-douyin2"></i>
        </CollectionRecommend>

        <!-- 更多潮图 -->
        <TrendPics v-if="trendPics.length" :trend-pics="trendPics"/>

      </div>
    </div>

    <no-ssr>
      <!--      <ActLoginCouponBar />-->
      <ActSlot/>
    </no-ssr>
  </div>
</template>

<script>
// components
import {
  getMaterialDetail,
  getMaterialSuite,
  getTrendList,
  glanceDetail,
  toggleMaterialCollect,
  downStat,
  getMaterialDetailInfo,
  detailTopicList,
  getPicCategory,
  getMaterialDetailPPT,
} from "@/api/material";

import {fnBrowser, fnCollection, fnLogin, fnPay, fnRouter, fnTopic, fnUser, fnVip} from "~/fn";
import {
  MATERIAL_DETAIL,
  IMG_BASE_URL,
  MEMBER_LICENSE_VIP_PATH,
  MEMBER_LICENSE_VIP, PAY,
} from "@/constant/PATH";
import memberExtend from "@/components/member/common/member-extend";
import {packageStat} from "@/api/stat";
import {MODEL_ACT_DETAIL_RED_COUPON, MODEL_PIC_ID} from "@/constant/MODELS";
import {disposeDetailKeyword, getPicFormat} from "@/components/tupian/detail/module";
import {tag} from "@/utils/statUtil";
import {toolDevice} from "@/tools";
import {BROWSERS} from "@/constant/SYSTEM";
import {listObjToArray} from "@/components/tupian/detail/common";
import axios from 'axios'
import ComponentMixin from "@/components/tupian/common/componentMixin";
import {TUPIAN_DETAIL} from "~/constant/tupian/TUPIAN_DETAIL";
import {PAGE_PATH} from "@/constant/PAGE_PATH";
import {TOPIC} from "@/constant/tupian/TOPIC";
import mixin from "@/pages/detail/mixin";
import {checkDetailShareLink, getDetailInviteStatus} from "../../api/act/detail-invite-down";
import {fnMaterial, fnPic} from "../../fn";
import {getAccountIsVip} from "../../api/user";


/* 引入公共方法和常量 */
import * as fnCommon from '@/fn/_fn';
import * as CON_COMMON from '@/constant/_constant';
import _ from 'lodash'

/* 引入组件 */
import DownloadInterestModal from '@/components/_components/pic/detail/DownloadInterestModal'
// import CouponModal from '@/components/_components/pic/detail/CouponModal'
// import ActLoginCouponBar from '@/components/_Privately/Act/ActLoginCouponBar'
import ActSlot from '@/components/_Privately/Act/ActSlot'

/* 引入VUEX */
import {mapState} from "vuex";
import {
  PAY_BUSINESS,
  PAY_BUSINESS_DEFAULT, PAY_COMPANY,
  PAY_COMPANY_DEFAULT,
  PAY_DEFAULT, PAY_PERSON,
  PAY_PERSON_DEFAULT
} from "@/constant/_constant/CON_BASIC";
import {checkCouponIsReceiveByRedPacketRain} from "@/api/act/detail-red-coupon";
import {MODAL_TRACK} from "@/constant/_constant/CON_CONFIG";
import FnUser from "@/fn/_fn/FnUser";
import {getCookie} from "@/utils/auth";
import {setPicFreeDownCouponModal} from "~/components/_Privately/Pic/PicFreeDownCouponModal/module";
import {setPicAttr, setPicViewType} from "@/components/_Privately/Pic/Common/module";
import {BLANK_LIST} from "@/constant/_Privately/User";
import CompanyController from "@/controller/companyController";

/* 引入API */


export default {
  name: "MaterialDetail",
  layout: "header-nav",
  components: {
    DownloadInterestModal,
    // ActLoginCouponBar,
    ActSlot
    // CouponModal
  },
  mixins: [memberExtend, ComponentMixin, mixin],
  computed: {
    ...mapState('base', ['isBoot', 'header', 'spider']),
    ...mapState('favorites', ['showDialog', 'showDialogByCompany']),
    ...mapState('user',
      [
        'personVipState',
        'personVipInfo',
        'businessVipState',
        'businessVipInfo',
        'companyVipState',
        'companyVipInfo',
        'isLogin',
        'downloadCount', 'companyInfoByPerson', 'uniq_id',
      ]
    ),
    ...mapState('company', ['companyRecordState']),
    ...mapState('Modal', ['NewUserFreeDownGuideModal'])
  },
  watch: {
    /* 登录更新详情收藏 */
    isLogin: {
      handler(n, o) {
        if (n == true || n == false) {
          // this.init();

          if (n == true) {

            setTimeout(() => {
              this.getDetailInviteStatus();
              this.checkDetailShareLink();
              // this.checkIsShowActDetailRedCoupon();
              let id = this.$route.query.id || this.$route.params.id;
              this.customAHref = `/detail/${id}?inviteUserCode=${this.uniq_id}`


            }, 1500)
          }

        }
      },
      immediate: true
    },
    isSpider: {
      handler(n, o) {
        if (n == true || n == false) {
          this.$store.commit('base/SET_SPIDER', n)
        }
      },
      immediate: true
    },

    showDialog: {
      handler(n, o) {
        if (n == false) {
          this.getMaterialDetail();
        }
      }
    },

    showDialogByCompany: {
      handler(n, o) {
        if (n == false) {
          this.getMaterialDetail();
        }
      }
    },
  },
  head() {
    return {
      title: this.tkd.title,
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.tkd.keywords
        },
        {
          hid: 'description',
          name: 'description',
          content: this.tkd.description
        },
        {
          property: 'article:published_time',
          content: this.detail.create_time
        }
      ]
    }
  },
  // eslint-disable-next-line vue/order-in-components
  data() {
    return {
      picPackageDesc: {},  // 图片包描述
      picPackageDescState: false, // 图片包是否展示
      picResources: [], // 更多资源
      picResourcesState: true,  // 更多资源是否展示
      trendPics: [],  // 潮流图片列表
      trendPicsCover: {},  // 封面图
      detail: {},  // 详情
      showImgPanel: false,  // 展示面板—增加过渡动画
      isCollect: 0,
      MATERIAL_DETAIL,
      IMG_BASE_URL,
      MEMBER_LICENSE_VIP_PATH,
      MEMBER_LICENSE_VIP,
      tkd: {
        'title': '潮国创意_中国原创潮流_创意图片设计_正版商用版权素材库',
        'keywords': '潮国创意,中国元素,中国元素素材,潮流创意,创意设计,创意设计网站,原创设计,图片素材,潮流图片,潮流设计,设计图,创意作品',
        'description': '潮国创意是目前国内为设计师、创意机构和创作人员寻找高质量、吸睛创意设计资源的素材图片网站。包含各类潮流前沿、高品质正版原创图片素材，chaopx.com 是值得信懒、可商用的潮流设计网站。',
        'create_time': new Date()
      },
      isBuyPicPackage: false,
      timerList: [],
      timer: null,
      paymentData: {},
      clippingTime: 0,
      isSpider: false,
      type: -1,
      downloadWay: '', // 当前下载最高vip( 仅用于普通和商用vip判断 )
      couponReceiveState: false,
      picInfo: {},
      picInfoIsShow: false,
      PAGE_PATH,
      topicList: [],
      id: 0,
      picCategory: {}, // 图片分类信息

      inviteDownInfo: {},  // 邀请信息
      isShowSuccDialog: false,
      isShowByFailDialog: false,
      isNotVip: false,
      customAHref: "",
      seo_words:[]
    }
  },
  created() {
    this.getMaterialDetailInfo();


    // this.getTopicList()

    /* 查询图片一级id */
    // this.getPicCategory();
    this.getDetailInviteStatus();
  },
  async mounted() {
    // await this.checkIsShowActDetailRedCoupon();
    // let res = await getMaterialDetailPPT()
    // console.log(res)

    let id = this.$route.query.id || this.$route.params.id;
    this.topicPositionStat();
    await this.glanceDetail();
    await this.checkDetailShareLink();
    await this.getAccountIsVip();
    await this.$store.dispatch('user/getMaterialFreeDownloadNum');
    this.$localStorage.setItemDate(MODEL_PIC_ID, this.getPicUniqId())
    this.$store.commit('base/SET_SEARCH_VAL', '')

  },
  async asyncData({app, req}) {


    let UA = app.context.req.headers['user-agent']

    const {route} = app.context;
    let id = route.params.id;
    id = id.replace('.html', '');

    let [
      picDetail,
      picResources,
      trendPics,
      topicList,
      picCategory
    ] = await Promise.all([
      app.$api.getMaterialDetail({id}),
      app.$api.getMaterialSuite({uniq_id: id}),
      app.$api.getTrendList({uniq_id: id}),
      app.$api.detailTopicList({id: id}),
      app.$api.getPicCategory({id: id}),
    ])


    if (picDetail.data.package === 1) {
      app.$api.packageStat({event: 'view'})
    }


    /* 图片活动邀请所需邀请人数数量 */

    // console.log('picDetail.data.layer')
    // console.log(picDetail.data.layer)

    /* 处理推荐专题 将topic和pictures拼接起来 */
    // let tempTopic = fnCollection.convertToTopicPic(topicList.data.topic);
    let tempTopicList = []
    if (Object.prototype.toString.call(topicList.data) === '[object Object]') {
      if ('topic' in topicList.data && topicList.data.topic != null) {
        // topicList.data.topic = setPicViewType(topicList.data.topic);
        // topicList.data.topic = setPicAttr(topicList.data.topic);
        let tempTopic = fnCollection.convertToTopicPic(topicList.data.topic);
        tempTopic.forEach(item => item = setPicViewType(item))

        tempTopicList = tempTopicList.concat(tempTopic)

        /* 处理 */


      }
      if ('pictures' in topicList.data && topicList.data.pictures.length) {
        tempTopicList = tempTopicList.concat(topicList.data.pictures)
      }
    }

    picDetail.data.isCollect = picDetail.is_collect || false

    /* 增加爬虫推荐词 */
    let seo_words = [];
    if ('seo_words' in picDetail && picDetail.seo_words.length) {
      seo_words = picDetail.seo_words
    }

    return {
      detail: fnMaterial.disposeTupianDetail(picDetail.data),
      seo_words,
      tkd: picDetail.tkd,
      showImgPanel: true,
      isCollect: picDetail.is_collect,
      trendPics: listObjToArray(trendPics.data),
      trendPicsCover: picResources.master_pic,
      picResources: listObjToArray(picResources.data),
      isSpider: fnBrowser.isSpider(UA),
      topicList: tempTopicList,
      id,
      picCategory: picCategory.data
    }
  },

  methods: {

    init() {
      this.getMaterialDetail();
      this.getMaterialSuite();
      this.getTrendList();
      this.getMaterialDetailInfo();
      // glanceDetail({id: this.getPicUniqId()});
      this.getAccountIsVip();

      setTimeout(() => {
        this.$store.commit('base/SET_SEARCH_VAL', '')
      }, 300)

    },

    topicPositionStat() {
      if (this.topicList.length) {
        let tempTopList = this.topicList.filter(item => item.type == 3)
        let ids = tempTopList.map(item => item.id)
        fnTopic.positionStat(
          ids.toString(),
          TOPIC.POSITION_STAT.EVENT.EXPOSE,
          TOPIC.POSITION_STAT.POSITION.DETAIL_BOTTOM,
        )
      }
    },

    getPicCategory() {
      getPicCategory({id: this.id}).then(res => {
        this.picCategory = res.data.data;
      })
    },

    /* 运营查看图片详情浏览等信息 */
    getMaterialDetailInfo() {
      console.log({
        11111:1111
      })
      if (TUPIAN_DETAIL.OPERATOR.indexOf(this.uniq_id) > -1) {
        getMaterialDetailInfo({id: this.getPicUniqId()}).then(res => {
          console.log({
            res
          })
          this.picInfo = res.data.data;
          this.picInfoIsShow = true
        })
      } else {
        this.picInfoIsShow = false;
      }

    },
    async glanceDetail() {
      let res = await glanceDetail({
        'id': this.getPicUniqId(),
        "refererUrl": document.referrer
      }).then(res => {
      })
    },

    getPicUniqId() {
      let id = this.$route.params.id;

      return id.replace('.html', '');
    },

    /* 详情 */
    async getMaterialDetail() {

      let picDetail = await getMaterialDetail({
        id: this.getPicUniqId(),
      })

      let picDetailData = picDetail.data.data;

      /* 自定义图片包信息 */
      let {is_buy, uniq_id, title, pic_num, package_price, package_content, master_id} = picDetailData;
      let picPackageDesc, // 图片包部分信息
        isBuyPicPackage;  // 图片包是否购买
      if (parseInt(picDetailData.package) === 1) {
        packageStat({event: 'view'})
      }


      picDetail.data.data.isCollect = picDetail.data.is_collect || false


      this.isCollect = picDetail.data.is_collect;
      this.detail = fnMaterial.disposeTupianDetail(picDetailData)
      this.picPackageDesc = picPackageDesc
      this.isBuyPicPackage = isBuyPicPackage
      this.showImgPanel = true
      this.tkd = picDetail.data.tkd


    },

    /* 详情收藏 */
    toggleLike() {
      if (fnLogin.checkLogin()) {
        const {uniq_id} = this.detail;
        let act = parseInt(this.isCollect) === 0 ? 'collect' : 'remove';
        this.isCollect = parseInt(this.isCollect) === 0 ? 1 : 0;
        toggleMaterialCollect({
          uniq_id,
          act,
          pck: this.detail.package == 1 ? 'package' : ''
        }).then(res => {
          let msg = parseInt(this.isCollect) === 0 ? '已取消收藏' : '收藏成功';
          this.$myNotify.success(msg)

        })
      } else {
        this.$store.commit('user/SET_IS_SHOW_LOGIN', true);
      }

    },

    /* 更多系列图片  */
    async getMaterialSuite() {
      let picResources = await getMaterialSuite({uniq_id: this.getPicUniqId()})
      let picResourcesDate = picResources.data;
      let _picResources = []
      if (Object.prototype.toString.call(picResourcesDate) === '[object Object]' && Object.keys(picResourcesDate).length > 0) {
        for (const key in picResourcesDate.data) {
          _picResources.push(picResourcesDate.data[key])
        }
      }
      if (Object.prototype.toString.call(picResourcesDate) === '[object Array]' && Object.keys(picResourcesDate).length > 0) {
        _picResources = picResources.data.data;
      }

      this.picResources = _picResources
      this.trendPicsCover = picResourcesDate.master_pic


    },

    /* 更多潮图 */
    async getTrendList() {
      let picResources = await getTrendList({uniq_id: this.getPicUniqId()});
      let picResourcesDate = picResources.data;

      let _picResources = []
      if (Object.prototype.toString.call(picResourcesDate) === '[object Object]' && Object.keys(picResourcesDate).length > 0) {
        for (const key in picResourcesDate.data) {
          _picResources.push(picResourcesDate.data[key])
        }
      }
      if (Object.prototype.toString.call(picResourcesDate) === '[object Array]' && Object.keys(picResourcesDate).length > 0) {
        _picResources = picResources.data.data;
      }
      this.trendPics = _picResources


    },

    /*
    * 显示支付弹框*/
    showPayDialog(type) {
      this.dialogType = 2;
      if (fnLogin.checkLogin()) {
        tag('充值:图片包购买按钮:图片')
        this.$refs.PicPackagePayModal.showPayDialog(this.detail);

        /*tag('充值:图片包购买按钮:图片')
        fnPay.getPayCode(this.detail.uniq_id, 2).then(res => {
          let {payment, ali_pay, wechat_pay} = res;
          this.paymentData = payment;
          this.getPayResult(ali_pay.order_no)
          this.getPayResult(wechat_pay.order_no)
          this.$refs.PicPackagePay.isShow = true;
        })*/
      } else {
        this.$store.commit("user/SET_IS_SHOW_LOGIN", true);
      }
    },
    getPayResult(order_no) {
      this.timer = setInterval(() => {
        fnPay.getPayResult(order_no).then(res => {
          if (res.status === 1) {
            this.$refs.PaySuccessDialog.isShow = true;
            this.$refs.PaymentDialog.isShow = false;
            this.$refs.PicPackagePay.isShow = false;
            clearInterval(this.timer);// 满足条件时 停止计时

            this.timerList.forEach((item, index) => {
              clearInterval(item);
            })
            this.timerList = [];
            this.timer = 0;
          }
        })
      }, 2000)
      this.timerList.push(this.timer)
    },

    PayRetainCancel() {
      this.$refs.PayRetainDialog.isShow = false;
      this.$refs.PicPackagePay.isShow = false;
      this.clearTimer();
    },

    PayRetainConfirm() {
      if (this.dialogType == 1) {
        this.$refs.PaymentDialog.isShow = true;
      } else {
        this.$refs.PicPackagePay.isShow = true;
      }
    },

    /* 支付挽留 */
    closePayDialog() {
      this.$refs.PayRetainDialog.isShow = true;
    },

    clearTimer() {
      if (this.timer) {
        this.timerList.forEach((item, index) => {
          clearInterval(item);
        })
        this.timerList = [];
        this.timer = 0;
      }
    },

    /*download(channel, uniq_id) {
      let tempStr = `https://dl.chaopx.com/down/download?channel=${channel}&uniq_id=${uniq_id}`
      this.$axios.get(tempStr).then(res => {
        let {status, url, msg} = res.data.data;
        if (status === 1) {
          window.location.href = url;
          // downStat({uniq_id})
        } else {
          this.$myNotify.show(msg)
        }
      });
    }*/


    download: _.throttle(function (detail, channel) {

      /*if (FnUser.checkUserIsVip()) {
        let {$store} = $nuxt;
        let phone = getCookie('phone')
        console.log(phone)
        if (phone == '' || phone == 0) {
          $store.commit('user/SET_IS_SHOW_BIND_IPHONE_MODAL', true);
          return false;
        } else {
          $store.commit('user/SET_IS_SHOW_BIND_IPHONE_MODAL', false)
        }
      }*/


      if (fnLogin.checkLogin()) {

        /* 灰产账号封禁 */
        if (BLANK_LIST.indexOf(this.uniq_id) > -1) {
          console.log("灰产账号")
          this.$store.commit('Modal/SET_BLANK_MODAL', true)
          return false;
        }


        // if (
        //   this.companyInfoByPerson.is_company_member == 1 &&
        //   this.companyInfoByPerson.switch.type == 1
        // ) {
        //   if (this.companyInfoByPerson.company.status != 1) {
        //     // console.log('当前企业身份，请先认证')
        //     this.type = 2
        //     this.$refs.CompanyCertificateDialog.isShow = true
        //     return false
        //   } else {
        //     if (this.companyInfoByPerson.switch.id == null || this.companyInfoByPerson.switch.id == 0) {
        //       this.type = 3
        //       // console.log('请先认证主体')
        //       this.$refs.CompanyCertificateDialog.isShow = true
        //       return false
        //     }
        //   }
        // }

        let tempStr = `https://dl.chaopx.com/down/download?channel=${channel}&uniq_id=${detail.uniq_id}`;

        let route = this.$route

        /*if (route.query._topic_id) {
          tempStr = route.query._topic_id ? tempStr += `&topic_id=${route.query._topic_id}&refererUrl=${route.query._refererUrl}` : tempStr
        } else {
          tempStr += `&refererUrl=${document.referrer}`
        }*/

   /*     const reject_state = 0;
        if (reject_state == 0 || reject_state == 2){
          const MainAuthenticationStatus =  CompanyController.checkMainAuthenticationStatus(2,'212U192');
          return false;
        }
*/

        let previousRouteLink = document.referrer;

        /* 仅上个链接为专题页使用 */
        if (previousRouteLink.indexOf('/collection/') > -1) {
          let routerArr = previousRouteLink.split('/');
          let topic_id = parseInt(routerArr[routerArr.length - 1]) || 0;
          tempStr += `&topic_id=${topic_id}&refererUrl=${document.referrer}`;
        }

        // const reject_state = 3, reject_reason='1121221'
        //
        // if (reject_state === 0 || reject_state === 2 || reject_state === 3){
        //   CompanyController.checkMainAuthenticationStatus(reject_state,reject_reason);
        // }
        //
        // if (reject_state == 2){
        //   return false;
        // }

        axios.get(tempStr).then(res => {
          let {status, layer, time, url, msg, d_type, free_down, unauthorized=false, reject_state,reject_reason = ''} = res.data.data;

          if (reject_state == 2 || reject_state == 3){
            CompanyController.checkMainAuthenticationStatus(reject_state,reject_reason);
          }

          /* 拒绝直接执行 */
          if (reject_state == 2){
            return false;
          }

          if (FnUser.checkCompanyVipExpiredModal()) {
            if (status == 0) {
              this.$store.commit('Modal/SET_COMPANY_VIP_EXPIRED_MODAL', true)
              return false;

            }
          }

          if (status === 1) {

            if(unauthorized == 1){
              CompanyController.checkMainAuthenticationStatus(0,reject_reason);
            }

            if (reject_state == 2){
              return false;
            }
            this.$store.dispatch('user/getMaterialFreeDownloadNum');
            downStat({uniq_id: detail.uniq_id})

            if (free_down == 1) {
              setPicFreeDownCouponModal(this.$store, true);
            }

            if (toolDevice.getCurrentBrowser() === BROWSERS.Safari) {
              setTimeout(() => {
                window.location.href = url;
              }, 200)
            } else {
              window.location.href = url;
            }

            // if(unauthorized){
            //   this.type = 3
            //   this.$refs.CompanyCertificateDialog.isShow = true
            // }


            /*if (parseInt(d_type) === 1) {
              setTimeout(() => {
                if (this.downloadCount.free_remain == 0) {
                  this.$store.commit('home/SET_IS_SHOW_GUIDE_DOWNLOAD_COUNT', true)
                } else {
                  this.$refs.ProfitModal.isShowFreeDownload = true
                }
              }, 600)

            }*/


            /*/!* 判断当前用户最高身份 *!/
            let personVipState = getCookie('personVipState')
            let businessVipState = getCookie('businessVipState')
            let companyVipState = getCookie('companyVipState')

            if (companyVipState == VIP_STATE.ON){
              return false
            } else{
              getCouponState({
                couponId:7
              }).then(res =>{
                let { data, status , is_used } = res.data;
                if (status === 200){
                  /!* 该优惠券已使用 *!/
                  if (data.is_used == 1){
                    // console.log('单账号仅可领取并使用一张 95折优惠券')
                    return false;
                  }

                  if (data.num == 0){
                    this.couponReceiveState = false
                    // console.log('未领取 95折 优惠券')

                  }else{
                    // console.log('已领取 95折 优惠券')
                    this.couponReceiveState = true
                  }

                  if (businessVipState == VIP_STATE.ON){
                    this.$refs.ReceiveCompanyCouponDialog.isShowFreeDownload = true;
                    this.downloadWay = 'BUSINESS'
                    return false
                  }else if (personVipState == VIP_STATE.ON){
                    this.$refs.ReceiveCompanyCouponDialog.isShowFreeDownload = true;
                    this.downloadWay = 'PERSON'
                    return false
                  }else{
                    this.$refs.ProfitModal.isShowFreeDownload = true
                  }
                }
              })
            }*/
          }
          /*else if (status === 0 || status === 2) {
            // tag('充值:详情页立即下载按钮:图片:click')
            // this.navigatorToPay();
          } */
          else if (status === 0 || status === 2 || status === 3) {
            // tag('充值:详情页立即下载按钮:图片:click')
            // this.navigatorToPay();
            tag('充值:详情页立即下载按钮:图片:click')
            /*if (layer == 2) {
              fnRouter.navigationTo(PAGE_PATH.PAYMENT.BUSINESS);
            } else if (layer == 3) {
              fnRouter.navigationTo(PAGE_PATH.PAYMENT.BUSINESS);
            } else if (layer == 4) {
              fnRouter.navigationTo(PAGE_PATH.PAYMENT.COMPANY);
            } else {
              fnRouter.navigationTo(PAGE_PATH.PAYMENT.BUSINESS);
            }*/

            // let openUrl = fnCommon.fnUser.getUserVipUpgradeLinkByPicLayer(parseInt(layer));
            // fnCommon.fnBasic.navigationTo(openUrl, "_blank")

            let personVipState = getCookie('personVipState')
            let personVipInfo = JSON.parse(getCookie('personVipInfo'))
            if (status === 2){
              this.$store.commit("_Privately/Pay/SET_SHOW_DOWN_LIMIT_BY_PERSON_YEAR_LIMIT_MODAL",true);
            }else{
              let openUrl = fnCommon.fnUser.getUserVipUpgradeLinkByPicLayer(parseInt(layer));
              fnCommon.fnBasic.navigationTo(openUrl, "_blank")
            }

            /*if (layer == 1 || layer == 2 || layer == 3 || layer == 4) {

              fnCommon.fnPic.showDownloadInterestModal(false);
              /!* 下载权益弹框判断 *!/
              let defaultParams = fnCommon.fnPic.getDownloadInterestParams();
              /!* 修改参数 *!/
              defaultParams.isShow = true;
              defaultParams.isOpenTimer = true; // 开启定时器
              defaultParams.upgradeLink = openUrl; // 设置升级按钮跳转链接
              fnCommon.fnPic.showDownloadInterestModal(true, defaultParams);
            }*/

          } else if (status === -200) {
            // this.clippingTime = time;
            // this.$refs.DownloadInterceptDialog.isShow = true;

            this.$store.commit('tupian/SET_DOWN_INTERCEPT_DIALOG', {isShow: true, clippingTime: time})

          }else if(status == 4){
            this.type = 3
            this.$refs.CompanyCertificateDialog.isShow = true
          }
        });


      } else {
        fnLogin.loginIntercept(false)
      }
    }, 2000),
    navigatorToPay(id = 2) {
      if (fnLogin.checkLogin()) {
        // this.isShowFreeDownload = false;
        this.$refs.ProfitModal.isShowFreeDownload = false;
        let path = `${PAY}/${id}`
        window.open(path, '_blank')
      } else {
        this.$store.commit("user/SET_IS_SHOW_LOGIN", 1);
      }

    },

    limitTag() {
      // tag("充值:非盈利用途弹窗:图片:click")
      tag('充值:详情页非盈利弹窗:图片:click')
    },

    async getTopicList() {
      let id = this.$route.params.id;
      id = id.replace('.html', '');

      let topicList = await detailTopicList({id: id})
      let tempTopicList = []
      if (Object.prototype.toString.call(topicList.data.data) === '[object Object]') {
        if ('topic' in topicList.data.data && topicList.data.data.topic != null) {
          let tempTopic = fnCollection.convertToTopicPic(topicList.data.data.topic);
          tempTopicList = tempTopicList.concat(tempTopic)
        }
        if ('pictures' in topicList.data.data && topicList.data.data.pictures.length) {
          tempTopicList = tempTopicList.concat(topicList.data.data.pictures)
        }
      }

      this.topicList = tempTopicList;
    },

    picItemTopicClick(topicId) {
      fnTopic.positionStat(
        topicId,
        TOPIC.POSITION_STAT.EVENT.CLICK,
        TOPIC.POSITION_STAT.POSITION.DETAIL_BOTTOM,
      )
    },

    topicMouseover(topicId) {
      fnTopic.positionStatMouseOver(
        topicId, TOPIC.POSITION_STAT.POSITION.DETAIL_BOTTOM,
      )
    },

    getDetailInviteStatus() {

      return false;
      if (this.isLogin) {
        getDetailInviteStatus({
          picId: this.getPicUniqId(),
        }).then(res => {
          this.inviteDownInfo = res.data.data;
        })
      }
    },

    checkDetailShareLink() {
      if (fnLogin.checkLogin()) {
        if (this.$route.query && this.$route.query.u) {
          checkDetailShareLink({
            inviter: this.$route.query.u,
            invitee: this.uniq_id,
            picId: this.detail.uniq_id,
            layer: this.detail.layer,
          }).then(res => {

            let {status} = res.data;

            if (status == 200) {
              this.isShowSuccDialog = true;

              this.$router.push({
                query: {}
              })


            } else {
              this.isShowByFailDialog = true;
            }
          })
        }
      }
    },

    /* 活动分享下载 */
    shareDown() {
      if (this.detail.is_ai == 1) {
        this.actDownloadFree(this.detail, 1)
      } else {
        this.actDownloadSourceFiles(this.detail, 2);
      }


    },

    actDownloadFree(tupianItem, channel, from = 'venue') {
      let {uniq_id} = tupianItem;
      // let tempChannel = 2
      fnPic.downloadPic(channel, uniq_id, from).then(res => {
        let {status, time, layer, url, msg, d_type} = res.data.data;
        if (status === 1) {

        } else if (status === 0 || status === 2 || status === 3) {
          /* 显示不不能下载的图片 */
          // this.imgUrl = PAGE_PATH.BASE_IMG_URL + tupianItem.proto_pic + '!/fw/672/quality/90/unsharp/true/compress/true'
          // this.shareUrl = PAGE_PATH.BASE_URL + PAGE_PATH.RABBIT_ACT.INVITE + '/' +  `picId=${uniq_id}&venue=${this.id}&inviter=${this.uniq_id}`;
        } else if (status === -200) {
          this.$store.commit('tupian/SET_DOWN_INTERCEPT_DIALOG', {isShow: true, clippingTime: time})
        }
      })
    },

    actDownloadSourceFiles(tupianItem, channel, from = 'venue') {
      // this.downloadFree(tupianItem, channel)
      let {uniq_id} = tupianItem;
      fnPic.downloadPic(channel, uniq_id, from).then(res => {
        let {status, time, layer, url, msg, d_type} = res.data.data;
        if (status === 1) {

        } else if (status === 0 || status === 2 || status === 3) {
          /* 显示不不能下载的图片 */
          if (layer == 2) {
            fnRouter.navigationTo(PAGE_PATH.PAYMENT.BUSINESS);
          } else if (layer == 3) {
            fnRouter.navigationTo(PAGE_PATH.PAYMENT.BUSINESS);
          } else if (layer == 4) {
            fnRouter.navigationTo(PAGE_PATH.PAYMENT.COMPANY);
          } else {
            fnRouter.navigationTo(PAGE_PATH.PAYMENT.BUSINESS);
          }
        } else if (status === -200) {
          this.$store.commit('tupian/SET_DOWN_INTERCEPT_DIALOG', {isShow: true, clippingTime: time})
        }
      })
    },

    getAccountIsVip() {
      getAccountIsVip().then(res => {
        let {
          business_vip_id,
          company_vip_id,
          personal_vip_id
        } = res.data.data;

        this.isNotVip = business_vip_id == 0 && company_vip_id == 0 && personal_vip_id == 0
      })
    },


    /**
     * 天降红包，用户当天第一次访问详情页，并且是 非企业成员才会显示
     */

    async checkIsShowActDetailRedCoupon() {
      setTimeout(async () => {
        console.log('--检查天降红包--');
        console.log(this.NewUserFreeDownGuideModal)


        /* 新用户登录免费下载引导提示弹框 拦截 */
        if (!fnLogin.checkLogin() || this.NewUserFreeDownGuideModal) {
          return false;
        }

        let dayIsShow = fnCommon.fnLocalStorage.getItemDate(MODEL_ACT_DETAIL_RED_COUPON)
        if (!dayIsShow) {
          let res = await checkCouponIsReceiveByRedPacketRain();
          if (res.data.data.rule == 0) {
            console.log('当日已领取');
            return false;
          }
          // 数据弹框统计
          let {TYPE, POSITION} = CON_COMMON.CON_CONFIG.MODAL_TRACK;
          await fnCommon.fnBasic.dataTrackByModal(POSITION.RED_PACKET_RAIN, TYPE.CURRENT_PAGE);

          this.$refs.CouponModal.isShow = true;
        } else {
          // this.$refs.CouponModal.isShow = false;
        }
      }, 500)
    }


  },


}
</script>

<style lang="scss" scoped>
@import "@/components/common/header/layout-header.scss";
.InviteReceive {
  width: 434px !important;
  padding-left: 32px !important;

  /deep/ .take {
    width: 164px !important;
  }
}

.bread-crumbs-box {
  width: 660px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}


.container {
  /deep/ .invite-cloud-box {
    top: 430px
  }
}

.material-detail-container {
  transition: all 0.5s ease-in-out;
  overflow: hidden;

  .inner-box {
    background-color: #fff;
    border-radius: 28px 28px 0 0;
    width: 1200px;
    //margin: 76px auto 0;
    margin: 0 auto 0;

    &.on {
      bottom: 0;
      visibility: visible;
    }

    &.no {
      bottom: -999px;
      visibility: hidden;
    }

  }

  .inner-container {
    //width: 1200px;
    //margin: 0 auto;
    background-color: #fff;
    //transition: all 0.5s ease-in-out;


    .level-box {
      display: flex;
      align-items: center;
      margin-top: 10px;

      a {
        &:hover {
          color: $color-primary;
        }
      }

    }

    .pic-wrap {
      display: flex;
      margin-bottom: 24px;
      //padding-top: 45px;
      position: relative;
      //transition: all 0.5s ease-in-out;

      .pic-img {
        width: 660px;
        //height: 749px;
        border-radius: 14px;
        margin-right: 60px;
      }

      .pic-introduce-panel {
        background-color: #fff;
        margin-left: 750px;
        transition: all 0.5s ease-in-out;
        //height: 764px;
        opacity: 0;

        &.active {
          opacity: 1;
        }

        &.on {
          position: absolute;
          bottom: 0;
        }

        &.no {
          position: fixed;
          //top: 170px;
          top: 135px;
          z-index: 2 !important;
        }


        .panel-title {
          //width: 434px;
          width: 100%;
          max-width: 434px;
          max-height: 74px;
          font-size: 28px;
          color: #0A2540;
          line-height: 37px;

        }

        .panel-author {
          height: 18px;
          font-size: 13px;
          color: #596088;
          line-height: 18px;
          letter-spacing: 1px;
          margin: 8px 0 24px;

        }

        .panel-btn-group {
          display: flex;

          .download-btn {
            width: 350px;
            height: 68px;
            background: $color-primary;
            border-radius: 14px;
            font-size: 20px;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 68px;
            letter-spacing: 1px;
            text-align: center;
            margin-right: 16px;
            @include ElementHover('', #5E5EE8);
          }

          .like-btn {
            width: 68px;
            height: 68px;
            border-radius: 14px;
            border: 1px solid #E0E3E9;
            @include LayoutFlex(1);

            i {
              font-size: 30px;
            }

            &.like-btn-default {
              background-color: #FFFFFF;
              @include ElementHover('', #EBEDF5);

              i {
                color: #424866;
              }
            }

            &.like-btn-active {
              background-color: #F8CC44;
              border-color: #F8CC44;
              @include ElementHover('', #DEB740);

              i {
                color: #FFFFFF;
              }
            }
          }
        }

        .panel-purpose {
          margin: 45px 0 41px;

          li {
            font-size: 18px;
            color: #001013;
            line-height: 20px;
            letter-spacing: 1px;
            margin-bottom: 22px;

            &:last-child {
              margin-bottom: 0;
            }

            .icon-gou {
              font-size: 22px;
              color: $color-primary;
              margin-right: 12px;
            }

            .icon-shield {
              font-size: 22px;
              margin-right: 5px;
              color: $color-primary;
            }

            span {
              color: $color-primary;
              margin-right: 4px;
            }
          }

        }

        .panel-pic-info {
          width: 434px;
          height: 320px;
          background: linear-gradient(180deg, rgba(245, 246, 250, 0) 0%, #F5F6FA 51%, rgba(245, 246, 250, 0) 100%);
          border-radius: 14px;
          padding: 26px 0 0 44px;
          box-sizing: border-box;

          dt {
            margin-bottom: 8px;

            .icon-image {
              @include IconFont(24px, #35D0BA)
            }

            .icon-ji {
              @include IconFont(24px, #6969FF)
            }

            .icon-calendar {
              @include IconFont(24px, #35D0BA)
            }
          }

          dd {
            display: flex;
            margin-bottom: 30px;

            .pic-item {
              width: 124px;
              height: 42px;
              border-radius: 2px;

              .title {
                margin-bottom: 4px;
                height: 18px;
                font-size: 13px;
                color: rgba(89, 96, 136, 0.65);
                line-height: 17px;
                letter-spacing: 1px;
              }

              .desc {
                font-size: 14px;
                font-weight: bold;
                color: rgba(89, 96, 136, 0.85);
                line-height: 20px;

              }
            }
          }

          .create-time {
            .pic-item {
              width: 186px;
              height: 42px;
            }
          }

          .application {
            .pic-item {
              .title {
                margin-bottom: 8px;
              }
            }

            .desc {
              display: flex;
            }

            .icon_ps {
              @include BgImage(26px, 26px, "home/images/application/icon-ps.svg");
              margin-right: 9px;
            }

            .icon_sketch {
              @include BgImage(26px, 26px, "home/images/application/icon-sketch.svg");
            }
          }

        }
      }
    }

    .pic-resources-wrap {
      //margin-bottom: 44px;
      //margin-top: 66px !important;

      .pic-title {
        height: 37px;
        font-size: 28px;
        font-weight: bold;
        color: #0A2540;
        line-height: 37px;
        letter-spacing: 1px;
        margin-bottom: 40px;

      }

      .pic-content {
        display: flex;
        flex-wrap: wrap;

        .pic-item {
          width: 279px;
          height: 279px;
          background: #FFFFFF;
          box-shadow: 0 0 16px 0 rgba(213, 221, 236, 0.4);
          border-radius: 14px;
          overflow: hidden;
          margin: 0 28px 28px 0;
          @include LayoutFlex(1);

          &:nth-child(4n) {
            margin-right: 0;
          }

          @include ElementHover('', '') {
            box-shadow: 0px 0px 15px 0px rgba(0, 0, 26, 0.12) !important;

            .pic-img {
              transform: scale(1.05);
            }
          }

          .pic-img {
            display: inline-block;
            width: 100%;
            //height: 100%;
            transition: all 0.5s ease-in-out;
            @include ElementHover('', '') {
              box-shadow: 0px 0px 15px 0px rgba(0, 0, 26, 0.12) !important;
            }
          }

          .pic-img-2 {
            //width: 279px;
            //height: 365px;
          }

        }

        .pic-item-2 {
          width: 279px;
          height: 365px;
        }

      }

    }

    .trend-pic-wrap {
      .pic-content {
        .pic-item {
          width: 279px;
          height: 365px;
          box-shadow: 0 0 25px 0 rgba(0, 0, 26, 0.06);
          border-radius: 14px;
        }
      }

    }
  }

  .PicResources {
    /deep/ .pic-resources-wrap {
      margin-bottom: 0px !important;
    }
  }

  .CollectionRecommend {
    background: #FFFFFF !important;
    width: 1200px !important;
    padding: 0 !important;
    margin-bottom: 20px !important;

    /deep/ .inner_center {
      width: 1200px !important;

      &.CollectionListHeader {
        height: 37px;
        color: #0A2540;
        margin-bottom: 40px;

        .title {
          font-size: 28px;
          font-weight: bold;
          color: #0A2540;
          line-height: 37px;
          letter-spacing: 1px;
        }

        a {
          font-size: 16px;
        }
      }

      .PicList {
        .PicItem {
          width: 279px;
          height: 365px;
          margin: 0 28px 28px 0;

          &:nth-child(4n) {
            margin-right: 0;
          }
        }

        .PicItemRecommend {
          width: 336px;
          height: 440px;
          border-radius: 14px;
          margin: 0 32px 40px 0;
          position: relative;
          transition: all 0.5s ease-in-out;
          display: flex;
          flex-direction: column;
          background: transparent;

          &:nth-child(4n) {
            margin-right: 0;
          }

          .shadow-box {
            content: '';
            display: inline-block;
            width: 100%;
            height: 399px;
            background: #FFFFFF;
            box-shadow: 0px 8px 16px 0px rgba(213, 221, 236, 0.4);
            border-radius: 14px;
            @include Position(1, 4, 0, 0);
            z-index: 1;
          }


          &:hover {
            .pic-img {
              transform: scale(1) !important;
            }

          }

          @include ElementHover('', '') {
            box-shadow: none !important;
          }

          .pic-shadow {
            width: 336px;
            height: 399px;
            background: #FFFFFF;
            box-shadow: 0px 8px 16px 0px rgba(213, 221, 236, 0.4);
            border-radius: 14px;
            @include Position(1, 4, 0, 0);
            z-index: 1;
          }

          .mask1 {
            width: 336px;
            height: 302px;
            background-size: cover;
            @include Position(1, 5, 0, 41px);
            z-index: 2;
            border-radius: 14px;
            overflow: hidden;

            i {
              display: inline-block;
              width: 100%;
              height: 100%;
              overflow: hidden;
              backdrop-filter: blur(20px);
              filter: blur(20px);
              border-radius: 14px 14px 0px 0px;
            }

            &:after {
              content: '';
              display: inline-block;
              width: 100%;
              height: 100%;
              @include Position(1, 5, 0, 0);
              background: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, #FFFFFF 100%);
            }
          }

          .mask2 {
            width: 308px;
            height: 320px;
            background-size: 100% 302px;
            @include Position(1, 5, 50%, 20px);
            transform: translateX(-50%);
            z-index: 3;
            border-radius: 14px;
            overflow: hidden;

            i {
              display: inline-block;
              width: 336px;
              height: 302px;
              overflow: hidden;
              backdrop-filter: blur(100px);
              filter: blur(100px);
              border-radius: 14px 14px 0px 0px;

            }

            &:after {
              content: '';
              display: inline-block;
              width: 100%;
              height: 100%;
              @include Position(1, 5, 0, 0);
              background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, #FFFFFF 100%);
            }
          }


          .pic-cover {
            @include Position(1, 5, 50%, 0);
            transform: translateX(-50%);
            z-index: 5;
            width: 278px;
            height: 360px;
            border-radius: 14px;
            overflow: hidden;

            .pic-img-wrap {
              display: inline-block;
              width: 100%;
              height: 100%;
              border-radius: 14px;

              .pic-img {
                display: inline-block;
                width: 100%;
                height: 100%;
              }
            }
          }

          .topic-info {
            width: 100%;
            height: 80px;
            @include Position(1, 4, 0, 0);
            z-index: 8;
            box-sizing: border-box;
            padding: 18px 18px 0;

            .topic-title {
              margin-bottom: 4px;
              display: flex;
              align-items: center;

              .title {
                max-width: 152px;

                font-size: 18px;
                font-weight: bold;
                color: #0A2540;
                line-height: 24px;
                letter-spacing: 1px;
              }

              .icon_view {
                @include BgImage(20px, 20px, 'topic/index/icon_yl.png');
                margin-left: 8px;
                position: relative;

                &:after {
                  content: '';
                  height: 8px;
                  background: transparent;
                  width: 80px;
                  @include Position(1, 5, 0, -3px);
                  display: none;
                }

                &:hover {
                  &:after {
                    display: block;
                  }

                  .topic-pictures-box {
                    display: block;
                  }
                }

                .topic-pictures-box {
                  width: 384px;
                  height: 264px;
                  background: #FFFFFF;
                  box-shadow: 0px 2px 8px 0px rgba(10, 37, 64, 0.1);
                  border-radius: 10px;
                  @include Position(1, 5, -4px, -268px);
                  z-index: 11;
                  padding: 10px 10px 0;
                  box-sizing: border-box;
                  display: none;

                  .topic-pictures {
                    display: inline-block;
                    width: 88px;
                    height: 114px;
                    border-radius: 6px;
                    overflow: hidden;
                    margin: 0 4px 4px 0;

                    &:hover {
                      img {
                        transform: scale(1.1);
                      }
                    }

                    &:nth-child(4n) {
                      margin-right: 0;
                    }

                    img {
                      display: inline-block;
                      width: 100%;
                      height: 100%;
                      transition: all 0.5s ease-in-out;
                    }
                  }

                }
              }
            }

            .topic-about {
              font-size: 12px;
              color: rgba(10, 37, 64, 0.6);
              line-height: 16px;
            }
          }

          .subscription {
            width: 84px;
            height: 32px;
            border-radius: 24px;
            position: relative;
            z-index: 2;
            @include Position(1, 3, 18px, 27px);
            display: flex;
            align-items: center;
            justify-content: center;


            .txt-subscription {
              font-size: 14px;
              color: #FFFFFF;
            }


            &.subscription-topic {
              background: linear-gradient(44deg, #FE7E7E 0%, #F94D67 100%);
              @include ElementHover('', linear-gradient(44deg, #F94D67 0%, #FE7E7E 100%));

              .icon-sub {
                display: inline-block;
                font-size: 14px;
                color: #FFFFFF;
                margin-right: 6px;
              }

              .txt-subscription {
                font-size: 12px;
                color: #FFFFFF;
                line-height: 16px;
              }

            }

            &.no-subscription-topic {
              background: #FFFFFF;
              border: 1px solid #ECEFF6;

              @include ElementHover('', #F7F9FD);

              &:after {
                background: rgba(66, 72, 102, 0.15);
              }

              .txt-subscription {
                color: #7A7E93;
                font-size: 12px;
              }

              .icon_subscription {
                @include BgImage(14px, 14px, 'topic/index/icon_subscription.svg');
                margin-right: 6px;

              }
            }
          }


          //@include Screen(1) {
          width: 279px;
          height: 364px;
          background: #FFFFFF;
          box-shadow: 0px 8px 16px 0px rgba(213, 221, 236, 0.4);
          border-radius: 14px;
          margin: 0 28px 36px 0;


          .shadow-box {
            height: 332px;

          }

          .mask1 {
            width: 279px;
            height: 251px;
          }

          .mask2 {
            width: 255px;
            height: 265px;
          }

          .pic-cover {
            width: 230px;
            height: 296px;
            border-radius: 14px;
          }

          .topic-info {
            height: 69px;
            padding: 13px 16px 0;

            .topic-title {
              .title {
                max-width: 133px;
                font-size: 16px;
                font-weight: bold;
                color: #0A2540;
                line-height: 21px;
                letter-spacing: 1px;
              }
            }

            .icon_view {
              @include BgImage(13px, 13px, 'topic/index/icon_yl.png');
            }
          }

          .subscription {
            width: 80px;
            height: 32px;
            border-radius: 24px;
            z-index: 2;
            @include Position(1, 3, 16px, 24px);
            display: flex;
            align-items: center;
            justify-content: center;


            .txt-subscription {
              font-size: 14px;
              color: #FFFFFF;
            }


            &.subscription-topic {
              background: linear-gradient(44deg, #FE7E7E 0%, #F94D67 100%);
              @include ElementHover('', linear-gradient(44deg, #F94D67 0%, #FE7E7E 100%));

              .icon-sub {
                display: inline-block;
                font-size: 14px;
                color: #FFFFFF;
                margin-right: 6px;
              }

              .txt-subscription {
                font-size: 12px;
                color: #FFFFFF;
                line-height: 16px;
              }

            }

            &.no-subscription-topic {
              background: #FFFFFF;
              border: 1px solid #ECEFF6;

              @include ElementHover('', #F7F9FD);

              &:after {
                background: rgba(66, 72, 102, 0.15);
              }

              .txt-subscription {
                color: #7A7E93;
                font-size: 12px;
              }

              .icon_subscription {
                @include BgImage(14px, 14px, 'topic/index/icon_subscription.svg');
                margin-right: 6px;

              }
            }
          }

          //}

        }

      }

    }


  }
}


.icon_maodian {
  @include BgImage(16px, 16px, 'tupian/maodian.svg');
  margin-right: 8px;
}

.DetailInviteDown {
  @include Position(1, 2, 0, -42px);
}


</style>
